module.exports = __webpack_public_path__ + "static/Screenshot (61)-3342d05e65c6607655db8a980876db97.png";